import { useCallback } from 'react';
import { usePlaybackStateStore } from '@annunciate/core';
export const usePlayerIndex = () => {
    return usePlaybackStateStore(useCallback(state => state.playerIndex, []));
};
//# sourceMappingURL=usePlayerIndex.js.map